import { render, staticRenderFns } from "./NextcloudStats.vue?vue&type=template&id=f714fe02&scoped=true"
import script from "./NextcloudStats.vue?vue&type=script&lang=js"
export * from "./NextcloudStats.vue?vue&type=script&lang=js"
import style0 from "./NextcloudStats.vue?vue&type=style&index=0&id=f714fe02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f714fe02",
  null
  
)

export default component.exports